import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { CustomCell } from "../models/diagram.models";

/**
 * Controla eventos de hover emitidos pelo Graph do MaxGraph.
 */
@Injectable({
    providedIn: "root"
})
export class MaxGraphEventBus {
    private readonly hoverLeave$ = new Subject<CustomCell>();
    private readonly hoverEnter$ = new Subject<CustomCell>();

    /**
     * Observable responsável por receber eventos de hoverEnter da célula.
     */
    onHoverEnter$(): Observable<CustomCell> {
        return this.hoverEnter$.asObservable();
    }

    /**
     * Emite o evento quando o mouse está sob uma célula do MaxGraph.
     */
    emitHoverEnter(cell: CustomCell): void {
        this.hoverEnter$.next(cell);
    }

    /**
     * Observable responsável por receber eventos de hoverLeave da célula.
     */
    onHoverLeave$(): Observable<CustomCell> {
        return this.hoverLeave$.asObservable();
    }

    /**
     * Emite o evento quando o mouse deixa a célula do MaxGraph.
     */
    emitHoverLeave(cell: CustomCell): void {
        this.hoverLeave$.next(cell);
    }
}
